  
  
/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
}

 
Shopify.formatMoney=function(h,a){var j=/\{\{\s*(\w+)\s*\}\}/;a=(a||this.money_format);if(typeof h=="string"){h=h.replace(/[^0-9]/g,"")}h=parseInt(h);h=h.toString();switch(h.length){case 0:h="000";break;case 1:h="00"+h;break;case 2:h="0"+h;break;default:break}var d=h.substr(h.length-2);var b=h.substr(0,h.length-2);var e=",";var i=".";function c(k,l){l=(l||",");return k.replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+l)}switch(a.match(j)[1]){case"amount_no_decimals":d="";i="";break;case"amount_with_comma_separator":e=".";i=",";break;case"amount_no_decimals_with_comma_separator":e=".";d="";i="";break;default:break}var g=c(b,e)+i+d;var f=a.replace(j,g);return f};
/*============================================================================
  API Functions
==============================================================================*/
/*===
ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};
 

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};


/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        var $addButtoncontainer = $formContainer.find('.product-add');
        $addButtoncontainer.before('<div class="errors qty-error">'+ data.description +'</div>');
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function(cart) {
    // Start with a fresh cart div
    var $preservedBar = $('#CartContainer .st-countdown-bar').detach();
    $cartContainer.empty();

if (cart.item_count === 0) {
  const collections = [
    { href: "/collections/phone-cases", imgVar: "//www.getcasely.com/cdn/shop/files/all_cases_240x.webp?v=1787154001", alt: "All Cases", text: "All Cases" },
    { href: "/collections/whats-new", imgVar: "//www.getcasely.com/cdn/shop/files/newarrivals_240x.webp?v=1787154001", alt: "New Arrivals", text: "New Arrivals" },
    { href: "/pages/club", imgVar: "//www.getcasely.com/cdn/shop/files/club_240x.webp?v=1787154001", alt: "Monthly Subscription Club", text: "Join the Club" },
    { href: "/collections/trending-phone-cases", imgVar: "//www.getcasely.com/cdn/shop/files/trendingcases_240x.webp?v=1787154001", alt: "Trending Cases", text: "Trending Cases" },
  ];

  const collectionLinks = collections.map(collection => `
    <a href="${collection.href}" class="cart__empty-collection">
      <img src="${collection.imgVar}" alt="${collection.alt}">
      <div>${collection.text}</div>
    </a>
  `).join('');

  const emptyCartHTML = `
    <div class="section-title"><span>Uh oh! Your cart is empty...</span></div>
    <div class="cart__empty-collections">${collectionLinks}</div>
  `;

  $cartContainer.html(emptyCartHTML);
  cartCallback(cart);
  return;
}

    // Handlebars.js cart layout
    var items = [],
      item = {},
      data = {},
      source = $('#CartTemplate').html(),
      template = Handlebars.compile(source);
      var cpTotal = 0;
      var saleTag;
      var prodImg;
      var addOns;
      var varTitle; 
      var device;

    
var addOnCategories = {
"iPhone 17": {"device": "17", "gsp": "41664758808679", "mysteryPrice": "", "mystery": "", "glassScreenPrivacy": "41664761299047", "privacy": "privacy"}, 
"iPhone 17 Pro": {"device": "17 Pro", "gsp": "41664735215719", "mysteryPrice": "", "mystery": "", "glassScreenPrivacy": "41664740720743", "privacy": "privacy"}, 
"iPhone 17 Pro Max": {"device": "17 Pro Max", "gsp": "41664726138983", "mysteryPrice": "", "mystery": "", "glassScreenPrivacy": "41664729808999", "privacy": "privacy"}, 
"iPhone 17 Air": {"device": "17 Air", "gsp": "41664748552295", "mysteryPrice": "", "mystery": "", "glassScreenPrivacy": "41664753729639", "privacy": "privacy"}, 
"iPhone 16": {"device": "16", "gsp": "40996865966183", "mysteryPrice": "Only $8", "mystery": "41637372199015", "glassScreenPrivacy": "40996866850919", "privacy": "privacy"}, 
"iPhone 16 Pro": {"device": "16 Pro", "gsp": "40996863606887", "mysteryPrice": "Only $8", "mystery": "41637372166247", "glassScreenPrivacy": "40996864196711", "privacy": "privacy"}, 
"iPhone 16 Pro Max": {"device": "16 Pro Max", "gsp": "40996857512039", "mysteryPrice": "Only $8", "mystery": "41637372100711", "glassScreenPrivacy": "40996859805799", "privacy": "privacy"}, 
"iPhone 16 Plus": {"device": "16 Plus", "gsp": "40996865015911", "mysteryPrice": "Only $8", "mystery": "41637372133479", "glassScreenPrivacy": "40996865474663", "privacy": "privacy"}, 
"iPhone 16e": {"device": "16e", "gsp": "41270243819623", "mysteryPrice": "",  "mystery": "", "glassScreenPrivacy": "41270240411751", "privacy": "privacy"}, 
"iPhone 15": {"device": "15", "gsp": "40182986834023", "mysteryPrice": "Only $8", "mystery": "41637372330087", "glassScreenPrivacy": "40182996598887", "privacy": "privacy"}, 
"iPhone 15 Pro": {"device": "15 Pro", "gsp": "40182987554919", "mysteryPrice": "Only $8", "mystery": "41637372264551", "glassScreenPrivacy": "40182996664423", "privacy": "privacy"}, 
"iPhone 15 Pro Max": {"device": "15 Pro Max", "gsp": "40182988275815", "mysteryPrice": "Only $8", "mystery": "41637372231783", "glassScreenPrivacy": "40182996795495", "privacy": "privacy"}, 
"iPhone 15 Plus": {"device": "15 Plus", "gsp": "40182987849831", "mysteryPrice": "Only $8", "mystery": "41637372297319", "glassScreenPrivacy": "40182996697191", "privacy": "privacy"}, 
"iPhone 14": {"device": "14", "gsp": "39884621217895", "mysteryPrice": "Only $8", "mystery": "41637372461159", "glassScreenPrivacy": "40138110042215", "privacy": "privacy"}, 
"iPhone 14 Pro": {"device": "14 Pro", "gsp": "39884621676647", "mysteryPrice": "Only $8", "mystery": "41637372395623", "glassScreenPrivacy": "40138109976679", "privacy": "privacy"}, 
"iPhone 14 Pro Max": {"device": "14 Pro Max", "gsp": "39884621742183", "mysteryPrice": "Only $8", "mystery": "41637372362855", "glassScreenPrivacy": "40138109943911", "privacy": "privacy"}, 
"iPhone 14 Plus": {"device": "14 Plus", "gsp": "39884622102631", "mysteryPrice": "Only $8", "mystery": "41637372428391", "glassScreenPrivacy": "40138110009447", "privacy": "privacy"}, 
"iPhone 13": {"device": "13", "gsp": "39464160362599", "mysteryPrice": "Only $8", "mystery": "39482230571111", "glassScreenPrivacy": "40138110140519", "privacy": "privacy"}, 
"iPhone 13 Pro": {"device": "13 Pro", "gsp": "39464233369703", "mysteryPrice": "Only $8", "mystery": "39482230538343", "glassScreenPrivacy": "40138110107751", "privacy": "privacy"}, 
"iPhone 13 Pro Max": {"device": "13 Pro Max", "gsp": "39464233402471", "mysteryPrice": "Only $8", "mystery": "39482230505575", "glassScreenPrivacy": "40138110074983", "privacy": "privacy"}, 
"iPhone 13 Mini": {"device": "13 Mini", "gsp": "39464234254439", "mysteryPrice": "Only $8", "mystery": "39482230603879", "glassScreenPrivacy": "", "privacy": ""}, 
"iPhone 12": {"device": "12", "gsp": "32906906435687", "mysteryPrice": "Only $5", "mystery": "39482230702183", "glassScreenPrivacy": "40138110271591", "privacy": "privacy"}, 
"iPhone 12 Pro": {"device": "12 Pro", "gsp": "32906907320423", "mysteryPrice": "Only $5", "mystery": "39482230669415", "glassScreenPrivacy": "40138110238823", "privacy": "privacy"}, 
"iPhone 12 Pro Max": {"device": "12 Pro Max", "gsp": "32906907385959", "mysteryPrice": "Only $5", "mystery": "39482230636647", "glassScreenPrivacy": "40138110206055", "privacy": "privacy"}, 
"iPhone 12 Mini": {"device": "12 Mini", "gsp": "32906905419879", "mysteryPrice": "Only $5", "mystery": "39482230734951", "glassScreenPrivacy": "", "privacy": ""}, 
"iPhone 11": {"device": "11", "gsp": "29992827224167", "mysteryPrice": "Only $5", "mystery": "39482230833255", "glassScreenPrivacy": "", "privacy": ""}, 
"iPhone 11 Pro": {"device": "11 Pro", "gsp": "29992821981287", "mysteryPrice": "Only $5", "mystery": "39482230800487", "glassScreenPrivacy": "", "privacy": ""}, 
"iPhone 11 Pro Max": {"device": "11 Pro Max", "gsp": "29992828993639", "mysteryPrice": "Only $5", "mystery": "39482230767719", "glassScreenPrivacy": "", "privacy": ""}, 
"iPhone 6/7/8": {"device": "6/7/8", "gsp": "52792054933", "mysteryPrice": "Only $5", "mystery": "39482231029863", "glassScreenPrivacy": "", "privacy": ""}, 
"iPhone 6/7/8 Plus": {"device": "6/7/8 Plus", "gsp": "52792132757", "mysteryPrice": "Only $5", "mystery": "39482230997095", "glassScreenPrivacy": "", "privacy": ""}, 
"iPhone XS Max": {"device": "XS Max", "gsp": "12758617751655", "mysteryPrice": "Only $5", "mystery": "39482230898791", "glassScreenPrivacy": "", "privacy": ""}, 
"iPhone XR": {"device": "XR", "gsp": "12758614704231", "mysteryPrice": "Only $5", "mystery": "39482230931559", "glassScreenPrivacy": "", "privacy": ""}, 
"iPhone X / XS": {"device": "X / XS", "gsp": "265180020757", "mysteryPrice": "Only $5", "mystery": "39482230964327", "glassScreenPrivacy": "", "privacy": ""}, 
"iPhone SE (2020 & 2022)": {"device": "SE (2020 & 2022)", "gsp": "32201430433895", "mysteryPrice": "Only $5", "mystery": "39482230866023", "glassScreenPrivacy": "", "privacy": ""}, 
"iPhone 8": {"device": "8", "gsp": "52792054933", "mysteryPrice": "Only $5", "mystery": "39482231029863", "glassScreenPrivacy": "", "privacy": ""}, 
"iPhone 8 Plus": {"device": "8 Plus", "gsp": "52792132757", "mysteryPrice": "Only $5", "mystery": "39482230997095", "glassScreenPrivacy": "", "privacy": ""}, 
"iPhone 7": {"device": "7", "gsp": "34906822342", "mysteryPrice": "Only $5", "mystery": "39482231029863", "glassScreenPrivacy": "", "privacy": ""}, 
"iPhone 7 Plus": {"device": "7 Plus", "gsp": "34906822406", "mysteryPrice": "Only $5", "mystery": "39482230997095", "glassScreenPrivacy": "", "privacy": ""}, 
"iPhone 6/6s": {"device": "6/6s", "gsp": "34906822214", "mysteryPrice": "Only $5", "mystery": "39482231029863", "glassScreenPrivacy": "", "privacy": ""}, 
"iPhone 6/6s Plus": {"device": "6/6s Plus", "gsp": "34906822278", "mysteryPrice": "Only $5", "mystery": "39482230997095", "glassScreenPrivacy": "", "privacy": ""}, 
"Galaxy S9": {"device": "S9", "gsp": "29763782606951", "mysteryPrice": "Only $5", "mystery": "39482231226471", "glassScreenPrivacy": "", "privacy": ""}, 
"Galaxy S9 Plus": {"device": "S9 Plus", "gsp": "29763789357159", "mysteryPrice": "Only $5", "mystery": "39482231193703", "glassScreenPrivacy": "", "privacy": ""}, 
"Galaxy S22": {"device": "S22", "gsp": "39626315399271", "mysteryPrice": "", "mystery": "", "glassScreenPrivacy": "", "privacy": ""}, 
"Galaxy S22 Ultra": {"device": "S22 Ultra", "gsp": "39626317463655", "mysteryPrice": "", "mystery": "", "glassScreenPrivacy": "", "privacy": ""}, 
"Galaxy S22 Plus": {"device": "S22 Plus", "gsp": "39626317234279", "mysteryPrice": "", "mystery": "", "glassScreenPrivacy": "", "privacy": ""}, 
"Galaxy S10E": {"device": "S10E", "gsp": "29763797778535", "mysteryPrice": "Only $5", "mystery": "39482243842151", "glassScreenPrivacy": "", "privacy": ""}, 
"Galaxy S10": {"device": "S10", "gsp": "29763793616999", "mysteryPrice": "Only $5", "mystery": "39482231160935", "glassScreenPrivacy": "", "privacy": ""}, 
"Galaxy S10 Plus": {"device": "S10 Plus", "gsp": "29763797418087", "mysteryPrice": "Only $5", "mystery": "39482231128167", "glassScreenPrivacy": "", "privacy": ""}, 
"Galaxy Note 10": {"device": "Note 10", "gsp": "30285227524199", "mysteryPrice": "Only $5", "mystery": "39482231095399", "glassScreenPrivacy": "", "privacy": ""}, 
"Galaxy Note 10 Plus": {"device": "Note 10 Plus", "gsp": "30285228965991", "mysteryPrice": "Only $5", "mystery": "39482231062631", "glassScreenPrivacy": "", "privacy": ""}
};

    var specialCategories = {
  "Auto renew": {special: "club", url: "https://www.getcasely.com/pages/club"},
  "Glass Screen": {special: "gsp"},
  "Wallet": {special: "wallet"},
  "Gift Box": {special: "giftbox"},
  "Phone Ring": {special: "phonering"},
  "Gift Card": {special: "giftcard"},
  "Pack": {special: "sticker"},
  "Phone Loop": {special: "loop"},
  "Mystery": {special: "mystery"},
  "Grippy": {special: "grippy"}
};

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
     saleTag = 'false';
      var comparePrice = '';
      var cp = 0;
           if (cartItem.image !== null) {
          if ((cartItem.title.includes(" Case") || cartItem.title.includes("Grippy") || cartItem.title.includes("Phone Loop")) && !cartItem.title.includes("AirPods") && !cartItem.title.includes("Kindle") && !cartItem.title.includes("iPad") && !cartItem.title.includes("Laptop")) {
        prodImg = cartItem.image.split("?")[0]
            + "?width=102&height=201&crop=center"; 
    } else {
        prodImg = cartItem.image
            .replace(/(\.[^.]*)$/, '_medium$1')
            .replace('http:', '');
    }
      } else {
        prodImg =
          '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
      }

     if (cartItem.properties !== null) {
  $.each(cartItem.properties, function(key, value) {
if (cartItem.handle.includes("customize-your-case")){
    if (key === '_custom_mockup_image') {
      prodImg = value.replace('upload','upload/c_crop,g_center,w_0.65,h_1');
    }
       if (key === 'Custom Text') {
      cartItem.properties[key] = 'Custom Text: ' + value;
    }
      if (key === 'Text Color') {
      cartItem.properties[key] = 'Text Color: ' + value;
    }
      if (key === 'Add Logo') {
      if (value === "true") {
        cartItem.properties[key] = "+ Love Island Logo";
      } else {
        // Hide the property entirely if it's false
        delete cartItem.properties[key];
      }
    }
  }
  if (cartItem.handle.includes("lucky-bandana-customizable-jenna-palek-x-casely-case")){
    if (key === '_custom_mockup_image') {
      prodImg = value.replace('upload','upload/c_crop,g_center,w_0.65,h_1');
    }
       if (key === 'Custom Text') {
      cartItem.properties[key] = 'Custom Text: ' + value;
    }
  }
    // Early return for '_Charity' key
    if ((key === '_Charity' && value) || (key === '_LPROP' && value)) {
      return true; // In jQuery.each, return true skips to the next iteration.
    }
  if ((key === '_compare') && value !== "" && comparePrice === "") {
      comparePrice = value * 100 * cartItem.quantity;
      cp = (comparePrice) - cartItem.final_line_price;
      comparePrice = Shopify.formatMoney(comparePrice, settings.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
    } 
    // Check for keys starting with '_' or empty values, excluding '_saleitem'
    if ( (key.charAt(0) === '_' && key !== '_saleitem') ||  !value){
      delete cartItem.properties[key];
      return true; // Skip further checks for this iteration.
    }

    // Specific checks and actions for keys
    if (key === '_saleitem') {
      if (value === 'saleitem'){saleTag = 'true';}
      delete cartItem.properties[key];
    } else if (key === 'shipping_interval_frequency') {
      cartItem.properties[key] = value == 1 ? 'Ships every month' : 'Ships every ' + value + " Months";
    } else if (key === 'shipping_interval_unit_type' || key === 'subscription_id' ||
               key === 'charge_interval_frequency' || key === 'charge_interval_unit_type' ||
               key === 'number_charges_until_expiration') {
      delete cartItem.properties[key];
    }
  });
 
}


var special = '', url = cartItem.url;
Object.keys(specialCategories).forEach(key => {
  if (cartItem.product_title.includes(key)) {
    special = specialCategories[key].special;
    url = specialCategories[key].url || url;
  }
});

if (cartItem.variant_title && cartItem.variant_title.indexOf(' / ') > 0) {
  varTitle = cartItem.variant_title.split(' / ').pop();
      }

var device = '', gsp = '', mystery = '', glassScreenPrivacy = '', mysteryPrice = '', privacy = '';
Object.keys(addOnCategories).forEach(key => {
  if (varTitle === key) {
    device = addOnCategories[key].device;
    gsp = addOnCategories[key].gsp;
    mystery = addOnCategories[key].mystery;
    mysteryPrice = addOnCategories[key].mysteryPrice;
    glassScreenPrivacy = addOnCategories[key].glassScreenPrivacy;
    privacy = addOnCategories[key].privacy;
    return;
  }
});      

      
var nameParts = cartItem.product_title.split(" | ");
var name1 = nameParts.slice(0, -1).join(" | ");
var name2 = nameParts[nameParts.length - 1].replace('40.00% Off Auto renew', '(Club Discount)').replace(name1, '');
      if (name1 === ''){name1 = name2; name2 = '';}

      // Optimize line level discount allocations formatting
      if (cartItem.line_level_discount_allocations.length > 0) {
        cartItem.line_level_discount_allocations.forEach((allocation) => {
          allocation.formattedAmount = Shopify.formatMoney(allocation.amount, settings.moneyFormat);
        });
      }
      
      // Optimize cart level discount applications formatting
      if (cart.cart_level_discount_applications.length > 0) {
        cart.cart_level_discount_applications.forEach((application) => {
          application.formattedAmount = Shopify.formatMoney(application.total_allocated_amount, settings.moneyFormat);
        });
      }

    let variantTitle = cartItem.variant_title || '';

if (variantTitle.includes('Default Title')) {
  variantTitle = variantTitle
    .replace('Default Title', '')
    .replace(' / ', '');
}

       
      
    
      
      cpTotal += cp; // Ensure cpTotal is declared and initialized earlier in the code
      
      // Create item's data object and add to 'items' array
      item = {  
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: url,
        img: prodImg,
        name: cartItem.product_title,
        name1: name1,
        name2: name2,
        ring: ring,
        variation: variantTitle,
        saleTag: saleTag,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(
          cartItem.original_line_price,
          settings.moneyFormat
        ).replace(/((\,00)|(\.00))$/g, ''),
        discountedPrice: Shopify.formatMoney(
          cartItem.final_line_price,
          settings.moneyFormat
        ).replace(/((\,00)|(\.00))$/g, '').replace('$0','FREE'),
        discounts: cartItem.line_level_discount_allocations,
        discountsApplied:
        cartItem.line_level_discount_allocations.length === 0 ? false : true,
        vendor: cartItem.vendor,
        special: special,
        gsp: gsp,
        gspP: glassScreenPrivacy,
        gspTitle: device,
        mystery: mystery,
        mysteryPrice: mysteryPrice,
        comparePrice: comparePrice,
        comparePriceNum: cp,
        privacy: privacy
 
      };
  
      items.push(item);
    });

    if (cart.total_discount !== null) {
      cpTotal = cpTotal + cart.total_discount;
    }

    var BeforeTotal =  cart.total_price + cpTotal;
    var fsThreshold =  30 * 100;

    if (BeforeTotal === cart.total_price){
      BeforeTotal = '';
    }

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      subTotalPrice:Shopify.formatMoney(
        cart.items_subtotal_price,
        settings.moneyFormat
      ).replace(/((\,00)|(\.00))$/g, ''),
      totalPrice: Shopify.formatMoney(
        cart.total_price,
        settings.moneyFormat
      ).replace(/((\,00)|(\.00))$/g, ''),
      moneyTilFreeShipping: Shopify.formatMoney(
        (fsThreshold - cart.total_price),
        settings.moneyFormat
      ),
      moneyTilFreeTwoShipping: Shopify.formatMoney(
        (10000 - cart.total_price),
        settings.moneyFormat
      ),
      FreeShippingPercentage: (cart.total_price/fsThreshold)*100,
      FreeTwoShippingPercentage: (cart.total_price/10000)*100,
      fsApplied:
      cart.total_price >= fsThreshold ? false : true,
      cartTotalDiscounts: Shopify.formatMoney(
        cart.total_discount,
        settings.moneyFormat
      ),
      TwofsApplied:
      cart.total_price < 10000 ? false : true,
      cartTotalDiscounts: Shopify.formatMoney(
        cart.total_discount,
        settings.moneyFormat
      ),
       ShipApplied:
      cart.total_price < 8000 ? false : true,
      cartTotalDiscounts: Shopify.formatMoney(
        cart.total_discount,
        settings.moneyFormat
      ),
      belowMin:
      cart.total_price >= 1000 || cart.total_price === 0 ? false : true,
      cartTotalDiscounts: Shopify.formatMoney(
        cart.total_discount,
        settings.moneyFormat
      ),
        zero:
      cart.total_price = 0  ? false : true,
      cartTotalDiscounts: Shopify.formatMoney(
        cart.total_discount,
        settings.moneyFormat
      ),
      cartBeforeDiscount: Shopify.formatMoney(
        BeforeTotal,
        settings.moneyFormat
      ).replace(/((\,00)|(\.00))$/g, ''),
      compareTotal: Shopify.formatMoney(
        (BeforeTotal),
        settings.moneyFormat).replace(/((\,00)|(\.00))$/g, ''),
      cartDiscounts: cart.cart_level_discount_applications,
      cartDiscountsApplied:
      cart.cart_level_discount_applications.length === 0 ? false : true,
      cpDiscountsApplied:
      BeforeTotal.length === 0 ? false : true,
      cartTotalSavings: cart.cart_level_discount_applications.length === 0 && cart.total_discount > 0
    };


    $cartContainer.append(template(data));
    $cartContainer.find('.ajaxcart__inner').prepend($preservedBar);

    cartCallback(cart);
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('ajaxCart.afterCartLoad', cart);
 

     if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }

  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--remove')) {
            qty = 0;
      } else{
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
    
    
  };

  adjustCartCallback = function (cart) {
    isUpdating = false;

    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };



  return module;

}(ajaxCart || {}, jQuery));



 
 
 